document.addEventListener("DOMContentLoaded", function() {
    const performanceTab = document.querySelector("#right-container .performance-tab");
    if (!performanceTab) return
    const subMenuButtons = performanceTab.querySelectorAll(".performance-menu .item");
    const subTabs = performanceTab.querySelectorAll(".performance-sub-tab");
    const logoImgHTML = performanceTab.querySelector(".main-info img");
    const companyNameHTML = performanceTab.querySelector(".main-info h3");
    const noStockMessage = performanceTab.querySelector(".no-stock-selected-message");
    const mainInfo = performanceTab.querySelector(".main-info");
    const performanceMenu = performanceTab.querySelector(".performance-menu");
    
    // Add error handler for company logo to hide it if 404/fail
    if (logoImgHTML) {
        logoImgHTML.onerror = function() {
            this.style.display = 'none';
        };
    }

    function updateStockSelectionState(hasStock) {
        if (noStockMessage && mainInfo && performanceMenu) {
            if (hasStock) {
                noStockMessage.style.display = 'none';
                mainInfo.style.display = '';
                performanceMenu.style.display = '';
                subTabs.forEach(tab => tab.style.display = '');
            } else {
                noStockMessage.style.display = 'flex';
                mainInfo.style.display = 'none';
                performanceMenu.style.display = 'none';
                subTabs.forEach(tab => tab.style.display = 'none');
            }
        }
    }

    function checkStockSelection() {
        const rightPanelDataHandler = document.querySelector('[right-panel-data-handler]');
        let hasStock = false;
        
        if (rightPanelDataHandler && rightPanelDataHandler.components && rightPanelDataHandler.components['right-panel-data-handler']) {
            const ticker = rightPanelDataHandler.components['right-panel-data-handler'].currentTicker;
            hasStock = !!ticker;
        }
        
        if (!hasStock && window.globalState && window.globalState.currentTicker) {
            hasStock = true;
        }
        
        updateStockSelectionState(hasStock);
    }

    checkStockSelection();

    setListeners();


    function setListeners() {
        if (!subMenuButtons || !subTabs) return

        subMenuButtons.forEach((currentButton, index) => {
            currentButton.addEventListener("click", () => {
                if (__LOG_INFO__) AppLog.info('click', index, subMenuButtons, subTabs)
                subMenuButtons.forEach(btn => btn.classList.remove("active"));
                subTabs.forEach(tab => tab.classList.remove("show"));

                currentButton.classList.add("active");
                subTabs[index].classList.add("show");

                const prettyGEventName = ['Price', 'Valuation', 'Dividends', 'Returns']
                if (window.gtag) gtag('event', `Desktop_RightPanel_Performance_${prettyGEventName[index]}`);
            })
        })

        const scene = document.querySelector('a-scene');
        if (scene) {
            scene.addEventListener('performance-data-updated', (e) => {
                if (__LOG_INFO__) AppLog.info(`ks: receive data`, e.detail);
                updateStockSelectionState(true);
                updateTab(e.detail);
            })
        }

        if (scene) {
            scene.addEventListener('stock-selected', () => {
                checkStockSelection();
            });
        }

        setInterval(checkStockSelection, 1000);

        document.addEventListener('tab-changed', (e) => {
            if (e.detail && e.detail.tabIndex === 1) {
                setTimeout(checkStockSelection, 100);
            }
        });

        if (window.AutoRefreshScheduler && !window.performanceTabScheduler) {
            window.performanceTabScheduler = new window.AutoRefreshScheduler({
                name: 'PerformanceTab',
                scheduleType: 'interval',
                intervalMinutes: 5,
                onRefresh: () => {
                    const rightPanelDataHandlerEl = document.querySelector('[right-panel-data-handler]');
                    if (rightPanelDataHandlerEl && rightPanelDataHandlerEl.components && rightPanelDataHandlerEl.components['right-panel-data-handler']) {
                        const handler = rightPanelDataHandlerEl.components['right-panel-data-handler'];
                        const ticker = handler.currentTicker;
                        if (ticker) {
                            handler.updateDataForTicker(ticker);
                        }
                    }
                }
            });
            window.performanceTabScheduler.start();
        }
    }

    function updateTab(updateData) {
        if (__LOG_INFO__) AppLog.info('ks: update performance tab', updateData)

        if (updateData.companyLogo && logoImgHTML) {
            logoImgHTML.style.display = ''; // Reset visibility before setting new src
            logoImgHTML.src = updateData.companyLogo;
        } else if (logoImgHTML) {
            logoImgHTML.style.display = 'none';
        }
        if (updateData.ticker && companyNameHTML) companyNameHTML.textContent = updateData.ticker


        // price sub-tab
        subTabs[0].innerHTML = ''
        createRow(subTabs[0], 'Prev close', updateData.prevClose, formatCurrency)
        createRow(subTabs[0], 'Open', updateData.open, formatCurrency)
        // createRow(subTabs[0], 'Bid', updateData.bid, formatCurrency)
        // createRow(subTabs[0], 'Ask', updateData.ask, formatCurrency)

        const daysRangeLow = updateData.daysRange?.low !== null && updateData.daysRange?.low !== undefined ? formatCurrency(updateData.daysRange.low) : 'N/A';
        const daysRangeHigh = updateData.daysRange?.high !== null && updateData.daysRange?.high !== undefined ? formatCurrency(updateData.daysRange.high) : 'N/A';
        createRow(subTabs[0], 'Days range', `${daysRangeLow} - ${daysRangeHigh}`, v => v)

        const range52Low = updateData.range52Week?.low !== null && updateData.range52Week?.low !== undefined ? formatCurrency(updateData.range52Week.low) : 'N/A';
        const range52High = updateData.range52Week?.high !== null && updateData.range52Week?.high !== undefined ? formatCurrency(updateData.range52Week.high) : 'N/A';
        createRow(subTabs[0], '52w Range', `${range52Low} - ${range52High}`, (v) => v)

        createRow(subTabs[0], 'Volume', updateData.volume, formatNumber)
        createRow(subTabs[0], 'Avg. Volume', updateData.avgVolume, formatNumber)
        createRow(subTabs[0], 'Market cap', updateData.marketCap, formatCurrency)
        createRow(subTabs[0], 'Short interest', updateData.shortInterestRatio * 100, prettifyPercentage, true)

        // valuation sub-tab
        subTabs[1].innerHTML = ''
        createRow(subTabs[1], 'Shares outstanding', updateData.sharesOutstanding, formatNumber)
        createRow(subTabs[1], 'Beta', updateData.beta5YMonthly, formatRatio)
        createRow(subTabs[1], 'PE ratio', updateData.peRatioTTM, formatRatio)
        createRow(subTabs[1], 'EPS (TTM)', updateData.epsTTM_Diluted, formatCurrency)
        createRow(subTabs[1], 'Forward PE ratio', updateData.forwardPERatioNTM, formatRatio)
        createRow(subTabs[1], 'Forecast EPS (QTR)', updateData.forecastEPSNQTR, formatCurrency)
        createRow(subTabs[1], 'Price to sales', updateData.priceToSalesTTM, formatRatio)
        createRow(subTabs[1], 'Price to book', updateData.priceToBookMRQ, formatRatio)
        createRow(subTabs[1], 'Price to free cash flow', updateData.priceToFreeCashFlowTTM, formatRatio)
        createRow(subTabs[1], 'Enterprise value/Revenue', updateData.enterpriseValueToRevenueTTM, formatRatio)
        createRow(subTabs[1], 'Enterprise value/EBITDA', updateData.enterpriseValueToEBITDA, formatRatio)


        // dividends sub-tab
        subTabs[2].innerHTML = ''
        createRow(subTabs[2], 'Earnings date', updateData.earningsDate, formatDate)
        const annualDiv = updateData.forwardDividendAndYield && updateData.forwardDividendAndYield.annualDividendPerShare !== null && updateData.forwardDividendAndYield.annualDividendPerShare !== undefined ? formatCurrency(updateData.forwardDividendAndYield.annualDividendPerShare) : 'N/A';
        const divYield = updateData.forwardDividendAndYield && updateData.forwardDividendAndYield.dividendYield !== null && updateData.forwardDividendAndYield.dividendYield !== undefined ? formatPercentageSimple(updateData.forwardDividendAndYield.dividendYield * 100) : 'N/A';
        createRow(subTabs[2], 'Dividend (TTM) and Yield', `${annualDiv} & ${divYield}`, v => v)
        createRow(subTabs[2], 'Dividend date', updateData.dividendDate, formatDate)

        // returns sub-tab
        subTabs[3].innerHTML = ''
        createRow(subTabs[3], 'Perf week', updateData.perfWeek, prettifyPercentage)
        createRow(subTabs[3], 'Perf Month', updateData.perfMonth, prettifyPercentage)
        createRow(subTabs[3], 'Perf 6M', updateData.perf6M, prettifyPercentage)
        createRow(subTabs[3], 'Perf YTD', updateData.perfYTD, prettifyPercentage)
        createRow(subTabs[3], 'Perf 1Y', updateData.perf1Y, prettifyPercentage)
        createRow(subTabs[3], 'Perf 5Y', updateData.perf5Y, prettifyPercentage)


        function createRow(parentEl, label, value, prettifyFunction, arrowNoNeed) {
            const labelString = `<span class="label">${label}</span>`;
            const valueString = `<span class="value">${prettifyFunction ? prettifyFunction(value, arrowNoNeed) : (value || 'N/A')}</span>`;
            const row = document.createElement('div');
            row.classList.add('data-row');
            row.innerHTML = `${labelString}  ${valueString}`;
            parentEl.appendChild(row);
        }
    }

    function isValidNumber(val) {
        return val !== null && val !== undefined && typeof val === 'number' && !isNaN(val);
    }

    function formatCurrency(initialNumber) {
        if (!isValidNumber(initialNumber)) return 'N/A';
        let number = initialNumber;
        const suffixes = ['', 'K', 'M', 'B', 'T'];
        let suffixIndex = 0;
        const isNegative = number < 0;
        number = Math.abs(number);

        if (number === 0) return '$0.00';

        while (number >= 1000 && suffixIndex < suffixes.length - 1) {
            number /= 1000;
            suffixIndex++;
        }
        
        const sign = isNegative ? '-' : '';
        return `${sign}$${number.toFixed(2)}${suffixes[suffixIndex]}`;
    }

    function formatNumber(initialNumber) {
        if (!isValidNumber(initialNumber)) return 'N/A';
        let number = initialNumber;
        const suffixes = ['', 'K', 'M', 'B', 'T'];
        let suffixIndex = 0;
        const isNegative = number < 0;
        number = Math.abs(number);

        if (number === 0) return '0.00';

        while (number >= 1000 && suffixIndex < suffixes.length - 1) {
            number /= 1000;
            suffixIndex++;
        }
        const sign = isNegative ? '-' : '';
        return `${sign}${number.toFixed(2)}${suffixes[suffixIndex]}`;
    }

    function formatRatio(initialNumber) {
        if (!isValidNumber(initialNumber)) return 'N/A';
        return initialNumber.toFixed(2);
    }
    
    function formatDate(dateStr) {
        if (!dateStr) return 'N/A';
        const parts = dateStr.split('-');
        if (parts.length === 3) {
             const [y, m, d] = parts;
             if (!isNaN(y) && !isNaN(m) && !isNaN(d)) {
                 return `${m}-${d}-${y.slice(-2)}`;
             }
        }
        return dateStr;
    }
    
    function formatPercentageSimple(initialNumber) {
        if (!isValidNumber(initialNumber)) return 'N/A';
        return `${initialNumber.toFixed(2)}%`;
    }

    function prettifyPercentage(value, arrowNoNeed = false) {
        if (value === null || value === undefined) return 'N/A'

        if (typeof value !== 'number') return 'N/A'

        if (isNaN(value)) return 'N/A'
        let sign = ''
        let arrow = ''
        if (!arrowNoNeed) {
            sign = value >= 0 ? '+' : ''
            arrow = value >= 0 ? '↑' : '↓'
        }

        return `${sign}${value.toFixed(2)}% ${arrow}`
    }

    this.remove = function() {
        if (window.performanceTabScheduler) {
            window.performanceTabScheduler.stop();
            window.performanceTabScheduler = null;
        }
    }
})
